import { app } from './1_app'

app.mount('#app')
